import { PAYMENT_METHOD } from 'constants/form';

export const usePaymentMethodOptions = (t: (key: string) => string) => {
  const map = {
    [PAYMENT_METHOD.CASH]: t('paymentMethod.cash'),
    [PAYMENT_METHOD.CREDIT]: t('paymentMethod.credit'),
    [PAYMENT_METHOD.BANK_TRANSFER]: t('paymentMethod.bankTransfer'),
    [PAYMENT_METHOD.OTA_DEBT]: t('paymentMethod.otaDebt'),
    [PAYMENT_METHOD.DEBT]: t('paymentMethod.debt'),
    [PAYMENT_METHOD.ONEPAY]: t('paymentMethod.onepay')
  };

  const paymentMethodOptions = Object.entries(map).map(([value, label]) => ({
    label,
    value
  }));

  const paymentMethodFilterOptions = [
    {
      label: t('common.statuses.all'),
      value: ''
    },
    ...paymentMethodOptions
  ];

  return {
    paymentMethodNames: map,
    paymentMethodOptions,
    paymentMethodFilterOptions
  };
};
